import React from 'react';
export const Kite = () => (
  <svg width="205px" height="154px" viewBox="0 0 205 154" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-231.000000, -737.000000)">
        <g transform="translate(231.000000, 737.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M88.8306,35.1303 L88.8306,37.1303"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M88.8306,41.1303 L88.8306,43.1303"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M92.8306,39.1303 L90.8306,39.1303"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M86.8306,39.1303 L84.8306,39.1303"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M160.3784,54.892 L160.3784,56.892"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M160.3784,60.892 L160.3784,62.892"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M164.3784,58.892 L162.3784,58.892"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M158.3784,58.892 L156.3784,58.892"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M104.3882,24.5365 C104.3882,25.3745 103.7092,26.0545 102.8702,26.0545 C102.0322,26.0545 101.3522,25.3745 101.3522,24.5365 C101.3522,23.6975 102.0322,23.0175 102.8702,23.0175 C103.7092,23.0175 104.3882,23.6975 104.3882,24.5365"
            fill="#F5C400"
          />
          <path
            d="M171.5406,87.5727 C171.5406,88.4117 170.8616,89.0907 170.0226,89.0907 C169.1846,89.0907 168.5046,88.4117 168.5046,87.5727 C168.5046,86.7347 169.1846,86.0547 170.0226,86.0547 C170.8616,86.0547 171.5406,86.7347 171.5406,87.5727"
            fill="#AA81F7"
          />
          <path
            d="M102.8706,152.9467 L157.6156,152.9467"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.7847,152.9467 L53.0287,152.9467"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.0284,152.9467 L37.9924,152.9467"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.0762,128.9594 L99.8712,70.8104 C100.0082,70.1854 100.5372,69.7244 101.1752,69.6734 L140.6592,66.5444 C141.4592,66.4804 142.1592,67.0784 142.2232,67.8784 L145.3522,107.3624 C145.4022,108.0004 145.0302,108.5964 144.4352,108.8294 L89.0272,130.6234 C87.9452,131.0494 86.8262,130.0954 87.0762,128.9594"
            fill="#F3F4F6"
          />
          <path
            d="M84.2867,115.3002 L97.0807,57.1522 C97.2187,56.5272 97.7477,56.0662 98.3857,56.0152 L137.8697,52.8862 C138.6697,52.8222 139.3697,53.4202 139.4327,54.2202 L142.5627,93.7042 C142.6127,94.3422 142.2407,94.9372 141.6457,95.1712 L86.2377,116.9652 C85.1557,117.3912 84.0367,116.4362 84.2867,115.3002"
            fill="#FFFFFF"
          />
          <path
            d="M140.3448,65.7221 L142.5628,93.7041 C142.6128,94.3421 142.2408,94.9371 141.6458,95.1711 L86.2378,116.9651 C85.1558,117.3911 84.0368,116.4361 84.2868,115.3001 L86.9408,103.2401"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.9112,98.8276 L97.0812,57.1516 C97.2192,56.5266 97.7482,56.0656 98.3852,56.0146 L137.8702,52.8866 C138.6702,52.8226 139.3702,53.4206 139.4332,54.2206 L139.9572,60.8326"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M119.625,75.8549 L86.995,114.1019"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M136.6431,55.9076 L124.0301,70.6906"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M122.6451,72.4125 L120.9271,74.4265"
            stroke="#CCD82B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M124.0303,75.8539 C130.7103,81.8049 136.1323,87.6729 140.4493,92.9019"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M99.5586,58.017 C105.4816,61.503 112.2156,65.997 119.2236,71.746"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M120.4951,72.5277 L122.7051,74.4137"
            stroke="#CCD82B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M64.003,128.4682 C60.187,129.1662 56.198,128.9062 52.548,127.5862 C50.36,126.7942 48.186,125.5432 47.093,123.4892 C46.001,121.4342 46.438,118.4542 48.494,117.3662 C49.915,116.6152 51.725,116.9432 53.062,117.8332 C56.183,119.9112 56.773,124.5442 55.163,127.9302 C53.554,131.3162 50.286,133.6162 46.908,135.2422 C43.53,136.8682 26.641,141.9522 23.385,143.8112"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M73.1617,125.436 C71.8597,126.023 70.5227,126.532 69.1587,126.959"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.166,119.4945 C80.622,120.9275 78.94,122.2015 77.155,123.3085"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.2442,119.9252 L74.2872,118.4892 C74.7802,118.2582 75.3432,118.6272 75.3272,119.1712 L74.9942,130.3832 C74.9772,130.9472 75.5822,131.3162 76.0762,131.0422 L79.0712,129.3822 C79.5142,129.1372 79.5782,128.5272 79.1962,128.1952 L71.0772,121.1352 C70.6802,120.7892 70.7682,120.1502 71.2442,119.9252"
            fill="#FFFFFF"
          />
          <path
            d="M71.2442,119.9252 L74.2872,118.4892 C74.7802,118.2582 75.3432,118.6272 75.3272,119.1712 L74.9942,130.3832 C74.9772,130.9472 75.5822,131.3162 76.0762,131.0422 L79.0712,129.3822 C79.5142,129.1372 79.5782,128.5272 79.1962,128.1952 L71.0772,121.1352 C70.6802,120.7892 70.7682,120.1502 71.2442,119.9252 Z"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.8452,122.2084 L67.0872,121.3054 C67.6112,121.1594 68.1042,121.6184 67.9962,122.1514 L65.7822,133.1474 C65.6712,133.7014 66.2042,134.1664 66.7382,133.9794 L69.9692,132.8474 C70.4472,132.6804 70.6132,132.0894 70.2922,131.6974 L63.4762,123.3724 C63.1432,122.9654 63.3382,122.3504 63.8452,122.2084"
            fill="#FFFFFF"
          />
          <path
            d="M63.8452,122.2084 L67.0872,121.3054 C67.6112,121.1594 68.1042,121.6184 67.9962,122.1514 L65.7822,133.1474 C65.6712,133.7014 66.2042,134.1664 66.7382,133.9794 L69.9692,132.8474 C70.4472,132.6804 70.6132,132.0894 70.2922,131.6974 L63.4762,123.3724 C63.1432,122.9654 63.3382,122.3504 63.8452,122.2084 Z"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.1001,94.0356 L91.5561,96.5106"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.5,64.9545 L92.745,91.1055"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.7852,108.7494 L95.1972,110.1804"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M133.5576,94.8832 L101.8176,107.5392"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M138.3721,85.8188 L136.8611,64.4948"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M107.8584,58.017 L131.0244,56.181"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(154.000000, 110.710000)">
            <path
              d="M44.2032,11.1674 L0.3782,11.2164 C0.3782,11.2164 0.3852,9.3934 3.3842,9.1004 C3.3842,9.1004 4.7782,6.3704 9.6222,6.0844 C9.6222,6.0844 11.0232,1.2274 16.7902,0.9444 C22.5572,0.6614 27.6132,5.8454 27.6132,5.8454 C27.6132,5.8454 32.9832,3.5474 36.3722,7.3964 C36.3722,7.3964 40.1762,7.6234 42.4992,9.0434"
              fill="#FFFFFF"
            />
            <path
              d="M44.2032,11.1674 L0.3782,11.2164 C0.3782,11.2164 0.3852,9.3934 3.3842,9.1004 C3.3842,9.1004 4.7782,6.3704 9.6222,6.0844 C9.6222,6.0844 11.0232,1.2274 16.7902,0.9444 C22.5572,0.6614 27.6132,5.8454 27.6132,5.8454 C27.6132,5.8454 32.9832,3.5474 36.3722,7.3964 C36.3722,7.3964 40.1762,7.6234 42.4992,9.0434"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(199.000000, 121.710000)">
            <path d="M0.1822,0.2162 L4.8342,0.2162" fill="#FFFFFF" />
            <path
              d="M0.1822,0.2162 L4.8342,0.2162"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(12.000000, 42.710000)">
            <path
              d="M54.0288,15.2963 L0.0268,15.3653 C0.0268,15.3653 0.0348,12.7753 3.7308,12.3583 C3.7308,12.3583 5.4478,8.4823 11.4178,8.0743 C11.4178,8.0743 13.1438,1.1753 20.2498,0.7743 C27.3568,0.3713 33.5868,7.7353 33.5868,7.7353 C33.5868,7.7353 40.2028,4.4713 44.3788,9.9403 C44.3788,9.9403 49.0668,10.2613 51.9288,12.2793"
              fill="#FFFFFF"
            />
            <path
              d="M54.0288,15.2963 L0.0268,15.3653 C0.0268,15.3653 0.0348,12.7753 3.7308,12.3583 C3.7308,12.3583 5.4478,8.4823 11.4178,8.0743 C11.4178,8.0743 13.1438,1.1753 20.2498,0.7743 C27.3568,0.3713 33.5868,7.7353 33.5868,7.7353 C33.5868,7.7353 40.2028,4.4713 44.3788,9.9403 C44.3788,9.9403 49.0668,10.2613 51.9288,12.2793"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(67.000000, 57.710000)">
            <path d="M0.2354,0.3656 L5.9674,0.3656" fill="#FFFFFF" />
            <path
              d="M0.2354,0.3656 L5.9674,0.3656"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
